import { Loader2, Search } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

interface SearchDeeperNoticeProps {
  /**
   * `searching` — список сам догружает совпадения глубже; `stalled` — предел
   * автодогрузки исчерпан, дальше по кнопке (#1048).
   */
  state: 'searching' | 'stalled';
  onContinue: () => void;
  className?: string;
}

/**
 * «Поиск продолжается глубже» (#1048).
 *
 * Поиск набирает страницу из порций совпадений, и порции могут почти целиком
 * отсеиваться правами: у агента в крупной организации свои записи лежат
 * глубоко. Пока совпадения не кончились, пустой список — не «ничего не
 * найдено», а «ищем дальше».
 */
export function SearchDeeperNotice({
  state,
  onContinue,
  className = '',
}: SearchDeeperNoticeProps) {
  const { t } = useTranslation('common');

  return (
    <div
      data-testid="search-deeper-notice"
      role="status"
      className={`flex items-center gap-2 text-xs text-fg-muted ${className}`}
    >
      {state === 'searching' ? (
        <>
          <Loader2 className="h-3.5 w-3.5 shrink-0 animate-spin" aria-hidden="true" />
          <span>{t('common.searchDeeperSearching')}</span>
        </>
      ) : (
        <>
          <Search className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
          <span>{t('common.searchDeeperStalled')}</span>
          <Button size="sm" variant="outline" onClick={onContinue}>
            {t('common.searchDeeper')}
          </Button>
        </>
      )}
    </div>
  );
}
